import React from "react";
import { IMG } from "../../constant";
import '../../sass/print.scss'

const HiddenPO = React.forwardRef(({ order }, ref) => {
  const address = JSON.parse(order.address || "{}");
  let products = [];
  try {
    products = typeof order.products === "string" ? JSON.parse(order.products) : order.products || [];
  } catch (e) {
    console.error("Error parsing products:", e);
    products = [];
  }

  const totalMRP = products.reduce((sum, item) => sum + item.mrp * item.quantity, 0);
  const totalOffer = products.reduce((sum, item) => sum + item.offer_price * item.quantity, 0);
  const totalSaved = totalMRP - totalOffer;

  return (
    <div
      id="print-area"
      ref={ref}
      style={{
        width: "800px",
        padding: "30px",
        fontFamily: "'Arial', sans-serif",
        backgroundColor: "#fff",
        color: "#333",
        fontSize: "16px"
      }}
    >
      {/* Page 1: Order Summary */}
      <div>
        <h2 style={{
          background: "#007a72", color: "#fff", padding: "10px 20px",
          textAlign: "center", margin: "0 -20px 20px", fontSize: "48px", 
        }}>
          PURCHASE ORDER
        </h2>

        <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "20px" }}>
          <div>
            <img src={IMG.logo} alt="DentalStores Logo" width="160" />
            <p style={{ marginTop: "10px", fontSize: "13px" }}>
              A unit of THDD<br />
              2nd floor, 4-1-1229, King Kothi Road,<br />
              Hyderabad - 500001, TS<br />
              Phone: 7093134343<br />
              Email: info@dentalstores.in<br />
              GST #36ACHPR8551J1Z1
            </p>
          </div>

          <div style={{ fontSize: "13px" }}>
            <strong>#PO-{order.po_number}</strong><br />
            <strong>Order Date:</strong> {order.po_date}<br /><br />
            <strong>Billing To</strong><br />
            Dr {address.fname} {address.lname}<br />
            Address: {address.address}<br />
            {address.city}, {address.state_name} - {address.pincode}<br />
            {address.country_name}<br />
            {address.landmark && <>Landmark: {address.landmark}<br /></>}
            Mobile: {address.phone}<br />
            Email: {address.email}
          </div>
        </div>

        <table width="100%" style={{ borderCollapse: "collapse", fontSize: "14px", marginBottom: "20px" }} border="1">
          <thead>
            <tr style={{ background: "#f5f5f5" }}>
              <th>#</th>
              <th>Product</th>
              <th>Quantity</th>
              <th>Price</th>
              <th>Total</th>
            </tr>
          </thead>
          <tbody>
            {products.map((item, i) => (
              <tr key={i}>
                <td style={{ textAlign: "center" }}>{i + 1}</td>
                <td style={{ padding: "8px" }}>{item.name}</td>
                <td style={{ textAlign: "center" }}>{item.quantity}</td>
                <td style={{ textAlign: "right" }}>₹ {item.offer_price.toFixed(2)}</td>
                <td style={{ textAlign: "right" }}>₹ {(item.offer_price * item.quantity).toFixed(2)}</td>
              </tr>
            ))}
          </tbody>
        </table>

        <div style={{ fontSize: "14px", marginBottom: "20px" }}>
          <div style={{ color: "green" }}>
            <strong>You saved</strong>: ₹ {totalSaved.toFixed(2)}
          </div>
          <div>Delivery Charges: ₹ {parseFloat(order.delivery_charges || 0).toFixed(2)}</div>
          <div style={{ color: "red" }}>COD Charges: ₹ {parseFloat(order.cod_amt || 0).toFixed(2)}</div>
          <div style={{ marginTop: "10px", fontWeight: "bold", fontSize: "16px" }}>
            Total Bill: ₹ {parseFloat(order.total || 0).toFixed(2)}
          </div>
        </div>

        <div style={{ fontSize: "13px", lineHeight: "1.5", marginTop: "20px" }}>
          <strong>Notes:</strong><br />
          Thank you for the Business!
        </div>
      </div>

      {/* Page 2: Terms and Conditions */}
      <div style={{ pageBreakBefore: "always", marginTop: "30px" }}>
        <h3 style={{ marginBottom: "10px" }}>Terms and Conditions</h3>
        <ul style={{ fontSize: "13px", paddingLeft: "20px", lineHeight: "1.8" }}>
          <li>Goods once sold cannot be taken back or exchanged.</li>
          <li>We are not the manufacturers; the company will stand for warranty as per their terms and conditions.</li>
          <li>Refund will be credited to store credit, and the customer can use it on the next purchase.</li>
          <li>Cancellations will be considered only if the request is made within 24 hours of placing an order.</li>
          <li>DentalStores.in area of Jurisdiction will be Hyderabad.</li>
        </ul>

        <div style={{ marginTop: "40px", textAlign: "center", fontSize: "13px" }}>
          ✤ For any enquiries, email us on support@dentalstores.in or call us on +91 70931 34343
        </div>
      </div>
    </div>
  );
});

export default HiddenPO;
